<div class="pb-4 edit-beneficiary-profile">
    <div class="form-group col-4">
        <label class="p-label common-bene-class-for-translation mr-3">Preferred Language</label>
        <p-dropdown class="w-100" appendTo="body" placeholder="Select" class="p-form-control" [options]="languageList"
          optionValue="code" [(ngModel)]="selectedLang.code" optionLabel="name">
        </p-dropdown>
    </div>
    <div>
        <div class="row">
            <div class="col" *ngFor="let language of languageList">
                <div class="border mb-3 px-2 py-3 d-flex align-items-center" [ngClass]="language.name !== selectedLang.name? '' : 'bg-success'">
                    <i *ngIf="language.name !== selectedLang.name" class="fa fa-circle-thin" style="font-size: 23px;"></i>
                    <i *ngIf="language.name == selectedLang.name" class="fa fa-check-circle text-white" style="font-size: 23px;"></i>
                    <span class="ml-3" [ngClass]="language.name !== selectedLang.name? '' : 'text-white'">{{language.name}}</span>
                </div>
            </div>
        </div>
    </div>
      <div class="px-3">
        <button class="btn btn-primary mt-3" (click)="saveChangeLanguage()"><span class="common-bene-class-for-translation">Save</span></button>
      </div>
</div>
    
         
        <!-- <li class="nav-item lang-menu">
          <span class="nav-link pr-0" href="javascript:void(0);"  id="navbarDropdownLang" role="button" data-toggle="dropdown"
            aria-haspopup="true" aria-expanded="false"><span>{{selectedLang ? selectedLang.name : 'Select Lang'}}</span>
            <img width="20"  height="20" src="https://img.icons8.com/ios/50/globe--v1.png" alt="globe--v1"/>
          </span>      
          <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdownLang"> 
            <a  *ngFor="let lang of languageList" class="dropdown-item"  
                href="javascript:void(0);" 
                (click)="handlerLanguageChange(lang)">{{lang.name}}</a>
          </div>
        </li> -->
  
